/* unplugin-vue-components disabled */import script from "./Exercises.vue?vue&type=script&setup=true&lang=js"
export * from "./Exercises.vue?vue&type=script&setup=true&lang=js"

import "./Exercises.vue?vue&type=style&index=0&id=d1c280c2&lang=scss"

const __exports__ = script;

export default __exports__